'use client';

import { useEffect } from 'react';

import { DEFAULT_SYSTEM_LANGUAGE } from '@/lib/constants';
import { ELocalStorageKeys, EQueryKeys } from '@/lib/enums';
import { EPortalRumEvents, logPortalRumError } from '@/lib/coralogix';
import { BootData } from '@/lib/types';
import { appStateService } from '@/state/app.state.service';
import { useAppState } from '@/state/hooks/app.state.hook';
import { webStorageUtil } from '@/state/webStorage.state.service';
import { useQuery } from '@tanstack/react-query';

import useAxios from './useAxios';

const temp_hardcoded = {
  storeTheme: {
    publisherId: '66be029440fd9d64e8b421a9',
    general: {
      bundlesViewModel: 'linear',
      bundlesInternalViewModel: 'baba',
      specialOffersViewModel: 'gallery',
      specialOffersInternalViewModel: 'jackpot-slots',
      productsQuantityFormat: {
        milSeparator: ',',
        fractionalSeparator: '.',
        thousandShorthand: true,
        millionShorthand: true,
        billionShorthand: true,
      },
      balanceQuantityFormat: {
        milSeparator: ',',
        fractionalSeparator: '.',
        thousandShorthand: true,
        millionShorthand: true,
        billionShorthand: true,
      },
      specialOfferQuantityFormat: {
        milSeparator: ',',
        fractionalSeparator: '.',
        thousandShorthand: true,
        millionShorthand: true,
        billionShorthand: true,
        _id: '67b4136fb39a9e7c1a885f4e',
      },
      headerBackgroundColor: {
        gradientDirection: 'to right',
        colorOne: '#6efc64',
        colorTwo: '#299900',
        _id: '66be029440fd9d64e8b421c2',
      },
      bottomStoreContent: ['FAQ'],
      sectionViewModel: 'bagelcode',
      balancesTheme: 'default',
      popupRatio: '1 / 1',
      storeSaleImage: '',
      openFooterLinksInNewTab: false,
      storeTabName: 'Gaming Store',
      accountApprovalModal: {
        backgroundImage:
          'https://media-dev.appcharge.com/media/66be029440fd9d64e8b421a9/1734976613226__c6bfd2b3-21b8-4005-b035-fa2b346e1b54',
        backgroundColor: {
          colorOne: '#7122ff',
          colorTwo: '',
          gradientDirection: '',
        },
        borderColor: '#f02424',
        borderWidth: 4,
        buttonBackgroundColor: {
          colorOne: '#dedede',
          colorTwo: '',
          gradientDirection: '',
        },
        buttonTextColor: '#0f17ff',
        textColor: '#000000',
      },
      footer: {
        imageMobile: '',
        imageDesktop: '',
        appstoreLink: 'https://www.google.com',
        googlePlayLink: '',
        privacyPolicyUrl: 'https://www.privacy222.com',
        termsAndConditionsUrl: 'https://www.tlc222.com',
        supportLink: 'https://www.supportlink222.com',
        openLinksInNewTab: false,
      },
      backgroundImageDesktop: 'https://media.appcharge.com/defaults/background.png',
      backgroundImageMobile:
        'https://media-dev.appcharge.com/media/66be029440fd9d64e8b421a9/1736437260126__8cc54f5c-0997-4d21-be7b-3792161652fe',
      favicon: 'https://media.appcharge.com/defaults/logo.svg',
      font: 'Anton',
      logo: 'https://media-dev.appcharge.com/media/66be029440fd9d64e8b421a9/1737454081098__1b3d95dd-54d8-46d0-8733-94eb859596eb',
      rollingOffersInternalViewModel: 'huge',
      sectionTextColor: '#ffffff',
    },
    login: {
      text: 'Welcome to a new members-only clubsfrr',
      font: 'Exo 2',
      textColor: '#000000',
      textSize: 22,
      textWeight: '500',
      otpButton: {
        backgroundColor: {
          colorOne: '#4e2f89',
          colorTwo: '',
        },
        textColor: {
          colorOne: '#bd2828',
          colorTwo: '',
        },
        icon: 'https://media.appcharge.com/defaults/logo.svg',
        text: 'OTP Text',
      },
      loginBackgroundImageMobile: '',
      loginBackgroundImageDesktop: '',
      loginLogoImage: '',
      loginLogoSize: 'small',
      openLinksInNewTab: false,
      consentSection: {
        htmlText:
          '<p>By logging <strong class="ql-size-large">innnnnninnnnnninnnnnn</strong> <a href="https://www.iberia.com/" rel="noopener noreferrer" target="_blank">iberia</a> link what ifffff i break the lineeeee will you be <span class="ql-size-small">thereeeeraraerae with </span>meee!@#$@%</p>',
        consentRequired: true,
      },
      accountApprovalModal: {
        backgroundImage: 'https://media.appcharge.com/defaults/background.png',
        backgroundColor: {
          colorOne: '#7122ff',
          colorTwo: '',
          gradientDirection: '',
        },
        borderColor: '#f02424',
        borderWidth: 4,
        buttonBackgroundColor: {
          colorOne: '#ff0000',
          colorTwo: '',
          gradientDirection: '',
        },
        buttonTextColor: '#00ff04',
        textColor: '#ffffff',
        additionalText: 'additionalllll',
      },
    },
    storeScreen: {
      bundleBorderColor: {
        colorOne: '#e3d3ff',
        colorTwo: '',
      },
      noOffersTitleText: 'No offers available',
      noOffersMessageText: 'Please check back later.',
      addToHomeScreen: {
        borderColor: {
          colorOne: '#ffffff',
          _id: '67b4cb9e9604aeb633dce6de',
        },
        backgroundColor: {
          colorOne: '#522AD8',
          colorTwo: '',
          _id: '67b4cb9e9604aeb633dce6df',
        },
        active: false,
        buttonImage: '',
        iconImage: 'https://media.appcharge.com/defaults/logo.svg',
        shortcutName: 'Gaming Store',
      },
      defaultBanner: '',
      defaultPlayerImage: 'https://media.appcharge.com/defaults/old-profile.png',
    },
    checkoutScreen: {
      logo: '',
      buttonColor: '#7122FF',
      buttonTextColor: '#FFF',
      primaryColor: '#CACBD4',
      textColor: '#000',
      _id: '66be029440fd9d64e8b421c6',
    },
    paymentScreen: {
      headerText: 'Payment Method',
      headerColor: {
        gradientDirection: '',
        colorOne: '#ffffff',
        colorTwo: '',
      },
      headerSize: 28,
      text: 'How you would like to pay?',
      textColor: '#ffffff',
      textSize: 16,
      popupColor: {
        gradientDirection: 'to bottom',
        colorOne: '#3b37a5',
        colorTwo: '#9892d1',
      },
      popupBorderColor: {
        gradientDirection: 'to bottom',
        colorOne: '#3b37a5',
        colorTwo: '#9892d1',
      },
    },
    completedScreen: {
      headerText: 'Success!!',
      headerColor: {
        colorOne: '#fbff00',
        colorTwo: '',
      },
      headerSize: 34,
      text: 'Relaunch your game to see your new itemssss',
      textColor: 'white',
      textSize: 12,
      headerWeight: '300',
      textWeight: '500',
      backToGameButtonText: 'Back to game',
    },
    createdAt: '2024-08-15T13:28:52.262Z',
    updatedAt: '2025-04-07T12:40:14.830Z',
    __v: 0,
    specialOfferQuantityFormat: {
      milSeparator: ',',
      fractionalSeparator: '.',
      thousandShorthand: true,
      millionShorthand: true,
      billionShorthand: true,
      _id: '66be029440fd9d64e8b421be',
    },
    storeTemplate: {
      _id: '67348c8af1647293095dc95d',
    },
    loginScreen: {
      accountApprovalModal: {
        backgroundImage:
          'https://media-dev.appcharge.com/media/66be029440fd9d64e8b421a9/1734976613226__c6bfd2b3-21b8-4005-b035-fa2b346e1b54',
        backgroundColor: {
          colorOne: '#7122ff',
          colorTwo: '',
          gradientDirection: '',
        },
        borderColor: '#f02424',
        borderWidth: 4,
        buttonBackgroundColor: {
          colorOne: '#dedede',
          colorTwo: '',
          gradientDirection: '',
        },
        buttonTextColor: '#0f17ff',
        textColor: '#000000',
      },
    },
  },
  integration: {
    playersAuthentication: {
      usernamePasswordOn: true,
      usernamePassword: {
        helpLink: {
          title: "Can't find your username?",
          url: 'https://maps.google.com/',
        },
      },
      userTokenOn: true,
      googleAppId: 'TBD',
      googleOn: false,
      appleAppId: 'TBD',
      appleOn: true,
      fbAppId: '611392880818813',
      fbOn: true,
      userTokenUrl: 'https://maps.google.com/',
      userTokenText: "Can't find your player ID?",
      otpAuthOn: false,
      otpLinks: [
        {
          platform: 'ios',
          deepLink: 'https://maps.google.com/',
        },
        {
          platform: 'android',
          deepLink: 'https://maps.google.com/',
        },
        {
          platform: 'web',
          deepLink: 'https://maps.google.com/',
        },
      ],
      appleResponseType: 'code',
      otpOn: true,
      otpTextModel: 'fourDigits',
      otpModel: 'dynamicLink',
    },
    deepLinks: [
      {
        platform: 'ios',
        deepLink: 'https://maps.google.com/',
      },
      {
        platform: 'android',
        deepLink: 'https://maps.google.com/',
      },
      {
        platform: 'web',
        deepLink: 'https://maps.google.com/',
      },
    ],
    googleAnalyticsMeasurementId: 'G-JB45B2RPXH',
    logRocketPublisherId: 'yokxf1',
    logRocketAppId: 'yokxf1',
    shouldUseLogRocket: false,
    supportUrl: 'https://7l0siu937f.execute-api.us-east-1.amazonaws.com/dev/supportPublisherServer',
    backToGameButtonOn: true,
    backToStoreButtonOn: true,
    checkoutPublicKey: '4c270153c723e4a3f9d7874b3398f41558cbafd3f9f0e28f53ca077177179a96',
    eventsWebhookUrl: '',
    enabledWebhookEvents: [
      'login_land',
      'login_canceled',
      'offers_shown',
      'order_created',
      'payment_intent_success',
      'payment_intent_failed',
      'order_completed_success',
      'order_completed_failed',
      'order_canceled',
      'order_refunded',
      'order_dispute_open',
      'order_dispute_lost',
      'order_dispute_won',
      'offers_loaded',
      'login_resolved',
      'login_method_selected',
    ],
  },
  publisher: {
    supportMail: 'support@appcharge.com',
    storeTabName: 'Gaming Store yayyay',
    gameLayout: 'None',
  },
  externalServicesConfig: {
    mixpanelActive: true,
    gaActive: true,
    logRocketActive: true,
  },
  featureFlags: {
    store_use_new_store_layout: true,
    integration_profiles: false,
    force_player_info_sync: false,
    store_sse_support: true,
    dashboard_banners: true,
    store_multi_language_support: false,
    store_deeplinks_disable_store: false,
    store_collect_animation_post_free_collect_promotions_popups: true,
    store_animation_after_purchases: true,
    store_add_to_home_screen_notification: false,
    dashboard_new_privacy_rich_text: true,
    store_post_purchase: false,
    store_remove_back_to_game_button_after_free: false,
    store_success_screen_hide_close_until_refetch: false,
    store_hide_mobile_background_overlay: false,
    store_localization_lowercase: false,
    store_show_version: false,
    store_independent_checkout_flow: true,
    store_loginv2: false,
    store_send_os_authlogin: false,
    store_present_daily_bonus_x_icon: true,
    store_successScreen_add_BackToStore_CTA: true,
    store_offers_jwt_validation: true,
    store_header_version_2: false,
    player_personalization_flow: false,
  },
  supportConfiguration: {
    externalSupportUrl: '',
    supportModel: 'AppCharge',
    preLoginSnippet: '',
    postLoginSnippet: '',
  },
  language: 'English',
};

export const useStoreBoot = () => {
  const { get } = useAxios();
  const { currentLanguage, initialBoot } = useAppState();
  const language =
    currentLanguage ||
    webStorageUtil.get(ELocalStorageKeys.CURRENT_LANGUAGE) ||
    DEFAULT_SYSTEM_LANGUAGE;

  const storeId =
    initialBoot?.stores?.[0] || webStorageUtil.get(ELocalStorageKeys.CURRENT_STORE_ID);

  const getBoot = useQuery<BootData, Error>({
    queryKey: [EQueryKeys.BOOT, storeId, language],
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: !!storeId,
    queryFn: async () => {
      try {
        if (webStorageUtil.get(ELocalStorageKeys.MOCK_BOOT_API)) {
          return JSON.parse(webStorageUtil.get(ELocalStorageKeys.MOCK_BOOT_API));
        }

        const storeId =
          appStateService.initialBoot.get()?.stores?.[0] ||
          webStorageUtil.get(ELocalStorageKeys.CURRENT_STORE_ID);

        const response = await get(`store/boot/${storeId}`, false, undefined, {}, true).catch(
          (err) => {
            throw err;
          }
        );

        return response;
      } catch (error: unknown) {
        const errorName = error instanceof Error ? error.name : 'UnknownError';
        logPortalRumError(EPortalRumEvents.PORTAL_LOADING_FAILED, {
          appSessionId: webStorageUtil.getStorageWithFallback()?.id,
          errorName,
          loadingArea: 'store-boot',
          reasonCode: 'store-boot-request-failed',
          storeId,
        });
      }
    },
  });

  return {
    getBoot,
  };
};
